import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let index = useDataValue({
    context: 'charge_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let charges = useDataValue({
    context: 'claim',
    path: 'charges',
    viewPath: props.viewPath,
  })
  let changeClaim = useDataChange({
    context: 'claim',
    viewPath: props.viewPath,
  })
  let changeInvoice = useDataChange({
    context: 'invoice',
    viewPath: props.viewPath,
  })

  return function onClick(action) {
    switch (action) {
      case 'REMOVE':
        return removeCharge()
      case 'MOVE_TO_INVOICE':
        return moveToInvoice()
      default:
        return
    }
  }

  function removeCharge() {
    changeClaim(next => {
      next.charges.splice(index, 1)
    })
  }

  function moveToInvoice() {
    changeInvoice(next => {
      next.charges.push(charges[index])
    })
    changeClaim(next => {
      next.charges.splice(index, 1)
    })
  }
}
